import type { Dispatch, ReactElement, SetStateAction } from 'react'
import type { Layer } from 'leaflet'
import createNamedContext from '../createNamedContext'
import useRequiredContext from '../../hooks/useRequiredContext'
import { InfoBoxProps } from '../../../types/mapDetailTypes'

export interface MapState {
  activeEmbeddedMapLayers: string[]
  featureLayers: Layer[]
  panelActive: boolean
  showLargeMap: boolean
  showMap: boolean
  showMapDrawVisualization: boolean
  panoFullScreen: boolean
  legendActive: boolean
  panoActive: boolean
  panoImageDate: Date | null
  panelHeader: {
    type?: string | null
    customElement?: ReactElement<any, any> | null
    title?: string | null
  }
  infoBox?: InfoBoxProps
  outOfBounds: boolean
  distanceText?: string
  drawToolLocked: boolean
}

type Action<T extends keyof MapState> = Dispatch<SetStateAction<MapState[T]>>

export interface MapContextProps extends MapState {
  setFeatureLayers: Action<'featureLayers'>
  setPanelActive: Action<'panelActive'>
  setPanoFullScreen: Action<'panoFullScreen'>
  setPanelHeader: Action<'panelHeader'>
  setShowLargeMap: Action<'showLargeMap'>
  setShowMap: Action<'showMap'>
  setShowMapDrawVisualization: Action<'showMapDrawVisualization'>
  setLegendActive: Action<'legendActive'>
  setInfoBox: Action<'infoBox'>
  setActiveEmbeddedMapLayers: Action<'activeEmbeddedMapLayers'>
  setOutOfBounds: Action<'outOfBounds'>
  setPanoImageDate: Action<'panoImageDate'>
  setDistanceText: Action<'distanceText'>
  setDrawToolLocked: Action<'drawToolLocked'>
}

const MapContext = createNamedContext<MapContextProps | null>('Map', null)

export function useMapContext() {
  return useRequiredContext(MapContext)
}

export default MapContext
